import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";
import { KccLineChart, KccAreaChart } from "@/components/kcc/Charts";

const IMG = "https://images.pexels.com/photos/32845695/pexels-photo-32845695.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Plant360() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/plant/overview").then(({ data }) => setData(data)); }, []);

    const daily = (data?.daily || []).map((d) => ({
        date: d.date.slice(5, 10),
        throughput: d.throughput_tpd,
        cu_rec: d.cu_recovery,
        co_rec: d.co_recovery,
        cu_grade: d.cu_grade_feed,
        energy: d.energy_kwh_t,
    }));

    return (
        <div className="space-y-6">
            <ModuleHeader
                kicker="Plant360"
                title="Concentrator, Hydromet & Refinery"
                description="End-to-end plant intelligence — crushing, milling, flotation, leach, SX-EW and cobalt circuit. Recovery, throughput and reagent optimisation."
                image={IMG}
            />
            <KpiGrid kpis={data?.kpis || []} accent="cobalt" cols={4} />

            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                <Panel title="Cu & Co Recovery" subtitle="90-day recovery trend" accent="copper">
                    <KccLineChart
                        data={daily.slice().reverse()}
                        series={[
                            { key: "cu_rec", label: "Cu Recovery %", color: "#e88c4a" },
                            { key: "co_rec", label: "Co Recovery %", color: "#4f8bd9" },
                        ]}
                        height={280}
                    />
                </Panel>
                <Panel title="Throughput (tpd)" subtitle="Concentrator daily throughput" accent="cobalt">
                    <KccAreaChart data={daily.slice().reverse()} dataKey="throughput" label="tpd" color="#2d68c4" height={280} />
                </Panel>
            </div>

            <Panel title="Process Streams — Live" subtitle="Real-time process unit status" accent="copper">
                <DataTable
                    columns={[
                        { key: "tag", label: "Tag" },
                        { key: "name", label: "Stream" },
                        { key: "area", label: "Area" },
                        { key: "current_rate", label: "Current", render: (r) => `${r.current_rate} ${r.unit}` },
                        { key: "capacity", label: "Capacity", render: (r) => `${r.capacity} ${r.unit}` },
                        { key: "availability_pct", label: "Avail", render: (r) => `${r.availability_pct}%` },
                        { key: "recovery_pct", label: "Recovery", render: (r) => (r.recovery_pct ? `${r.recovery_pct}%` : "—") },
                        { key: "power_kw", label: "Power (kW)", render: (r) => r.power_kw.toLocaleString() },
                        { key: "status", label: "Status", render: (r) => <StatusChip status={statusToChip(r.status)}>{r.status.replace("_", " ")}</StatusChip> },
                    ]}
                    rows={data?.streams || []}
                    testid="streams-table"
                />
            </Panel>
        </div>
    );
}
